var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header-box" }, [
    _c("div", { staticClass: "yve" }, [
      _c("span", { staticClass: "test" }, [_vm._v("累计发放积分总额")]),
      _c("span", { staticClass: "money" }, [_vm._v(_vm._s(_vm.surplus))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }